import { create } from "zustand";
import { persist } from "zustand/middleware";

const useHierarchyStore = create(
  persist(
    (set) => ({
      selectedDimensionId: null,
      setSelectedDimensionId: (id) => set({ selectedDimensionId: id }),
      // Folded-subtree state per perspective + view ("<dimensionId>:<viewMode>") → array of
      // collapsed node ids. Persisted so a user's fold/unfold choices stick across sessions.
      collapsedByKey: {},
      setCollapsedForKey: (key, ids) =>
        set((state) => ({ collapsedByKey: { ...state.collapsedByKey, [key]: ids } })),
    }),
    {
      name: "hierarchy-store",
      partialize: (state) => ({
        selectedDimensionId: state.selectedDimensionId,
        collapsedByKey: state.collapsedByKey,
      }),
    }
  )
);

export default useHierarchyStore;
